import React from "react";
import textareastyles from "./textarea.module.css";
import basestyles from "../../styles/basestyles.module.css";

export default function Textarea(props) {
  return (
    <>
      <div className={basestyles.inputWidth}>
        <textarea
          className={textareastyles.textareaTag}
          type={props.type}
          placeholder={props.placeholder}
          name={props.name}
          onChange={props.onChange}
          value={props.value}
        />
      </div>
    </>
  );
}
